const inviteAddTenant = {
  toastr: 'Tenant Added',
  toastr1: 'The tenant has been successfully added.',
  toastrError: 'Incorrect password'
};

export default inviteAddTenant;
